// ProfilHatasi.js — GİRİŞ YAPANIN PROFİLİ: TEK OKUMA + TEK EKRAN, OKUNAMADI ≠ YOK (21 Eki 2026, kod taraması W4b)
//
// 🔴 ÖNCESİ: profil üç yerde ayrı ayrı okunuyordu (App açılışı, ADMIN PANEL, SÜPER ADMİN) ve hiçbiri hatayı okumuyordu.
//    Okuma düşünce profil "yok" sayılıyordu: süper admin, şirket seçmeden sıradan admin paneline düşüyordu — orada da
//    profil okunamazsa şirket kapsamı boş kalıyor ve şirkete göre süzmeyen ekranlar (süper admin her şirketi okuyabilir)
//    bütün şirketlerin verisini gösterebiliyordu (İlke 10). Rol ve şirket profilden gelir; profil okunmadan panel açılmaz.
// Profil GERÇEKTEN yoksa (satır yok, hata yok) bugünkü davranış aynen kalır — bu yalnız okuma hatası içindir.
import React from 'react';
import { supabase } from '../supabaseClient';
import OkumaHatasi from './OkumaHatasi';
import CikisDugmesi from './CikisDugmesi';
import { TAM_YUKSEKLIK } from '../yaziBoyutu';

/** { profil, hata } — hata: sunucunun cümlesi (okuma düştü); profil null + hata null: o hesabın profili yok. */
export async function profilOku(kullaniciId) {
  try {
    const { data, error } = await supabase.from('profiles').select('id,role,customer_id,is_super_admin')
      .eq('id', kullaniciId).maybeSingle();
    if (error) return { profil: null, hata: error.message || String(error) };
    return { profil: data || null, hata: null };
  } catch (e) {
    return { profil: null, hata: e?.message || String(e) };
  }
}

export default function ProfilHatasi({ hata, onRetry, sonra }) {
  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:TAM_YUKSEKLIK,
                  background:'var(--bg)', padding:24 }}>
      <div style={{ maxWidth:560 }}>
        <OkumaHatasi testid="profil-okuma-hatasi" satirlar={[{ ad: 'YOUR PROFILE (profiles)', metin: hata }]} onRetry={onRetry}
          baslik="YOUR PROFILE COULD NOT BE LOADED — the panel is not opened without it: your role and company decide what you may see." />
        <div style={{ marginTop:12, maxWidth:200 }}><CikisDugmesi sonra={sonra} /></div>
      </div>
    </div>
  );
}
